export default "__VITE_ASSET__BhyAfQd1__"